<template>
  <div class="common-layout">
    <el-container class="container-screen">
      <el-aside class="left-menu-cong-viec">
        <el-menu
          ref="projectMenu"
          :default-active="activeMenu"
          :default-openeds="projectMenuDefaultOpeneds"
          @select="handleMenuSelect"
          @close="handleProjectMenuClose"
        >
          <el-menu-item index="" :class="['my-work', { 'active-menu': this.projectDetails.id === '' }]">
            <i class="el-icon-user" style="font-weight: 400; font-size: 20px"></i>
            Công việc của tôi
          </el-menu-item>
          <el-menu-item 
            index="add-project" 
            class="add-project-btn"
            @click="handleAddProject()">
            <i class="el-icon-plus" style="font-weight: 400; font-size: 20px; margin-right: 8px; color: #409EFF;"></i>
            Thêm dự án
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">Đã ghim</template>
            <el-menu-item v-for="project in listProjectPind" :key="`pin-${project.id}`" class="item-raw-wrapper"
              :index="`project-${project.id}`">
              <AvatarComponent :text="project.name" :imageUrl="project.avatar" :size="28" />
              <span class="project-name">{{ project.name }}</span>

              <!-- Tooltip + Icon -->
              <TooltipMenu
                :items="[
                  {
                    icon: '/img/un-pin.svg',
                    label: 'Bỏ Ghim',
                    onClick: () => handleUnPin(project.pinnedId),
                  }
                ]"
              />
            </el-menu-item>
          </el-submenu>

          <el-submenu index="2">
            <template slot="title">Tất cả</template>
            <el-menu-item v-for="project in listProject" :key="`project-${project.id}d`" class="item-raw-wrapper"
              :index="`project-${project.id}`">
              <AvatarComponent :text="project.name" :imageUrl="project.avatar" :size="28" />
              <span class="project-name">{{ project.name }}</span>

              <!-- Tooltip + Icon -->
              <TooltipMenu
                :items="[
                  {
                    icon: '/img/Pin.svg',
                    label: 'Ghim',
                    onClick: () => handlePin(project.id),
                    allowedRoles: ['*']
                  },
                  {
                    icon: '/img/Edit.svg',
                    label: 'Cập nhật',
                    onClick: () => handleUpdateProject(project),
                    allowedRoles: ['OWNER']
                  },
                  {
                    icon: '/img/delete-svgrepo-com.svg',
                    label: 'Xóa',
                    onClick: () => handleDeleteProject(project.id),
                    allowedRoles: ['OWNER']
                },
                ].filter(item => item.allowedRoles.includes('*') || item.allowedRoles.includes(project.myRole))"
              />
            </el-menu-item>
          </el-submenu>
        </el-menu>

      </el-aside>
      <el-container>
        <el-header class="header-band">
          <div class="item-raw-wrapper">
            <AvatarComponent v-if="projectDetails.id && projectDetails.id !== ''" :text="projectDetails.name"
              :imageUrl="projectDetails.avatar" :size="28" />
            <span class="project-name">{{ projectDetails.name }}</span>
          </div>
        </el-header>

        <el-main>
          <el-tabs type="card" v-model="tabs" class="tabs-work" @tab-click="handleTabs">
            <el-tab-pane name="work">
              <template slot="label">
                <div class="el-tab">
                  <img src="/img/CongViec.svg" alt="Công việc" style="width: 24px; height: 24px;" />
                  <span class="tab-text">Công việc</span>
                </div>
              </template>
            </el-tab-pane>
            <el-tab-pane name="member" v-if="this.projectDetails.id !== ''">
              <template slot="label">
                <div class="el-tab">
                  <img src="/img/Group.svg" alt="Biểu đồ" style="width: 24px; height: 24px;" />
                  <span class="tab-text">Thành viên</span>
                </div>
              </template>
            </el-tab-pane>
            <!-- <el-tab-pane name="statistical">
              <template slot="label">
                <div class="el-tab">
                  <img src="/img/BieuDo.svg" alt="Biểu đồ" style="width: 24px; height: 24px;" />
                  <span class="tab-text">{{ activeMenu === '' ? 'Báo cáo' : 'Thống kê' }}</span>
                </div>
              </template>
            </el-tab-pane> -->
          </el-tabs>
          <div class="screen-main">
            <div class="my-work-screen" v-if="tabs === 'work'">
              <div class="create-button" v-if="tabs === 'work' && tableData && tableData.length == 0">
                <el-button @click="openCreateWork" class="work-create">
                  <img src="/img/Add.svg" alt="Công việc" style="width: 24px; height: 24px; margin-right: 10px" />
                  <span> Tạo mới công việc</span>
                </el-button>
              </div>
              <!-- filter -->
              <div class="filter-form">
                <el-select placeholder="Chọn loại công việc" v-model="filterForm.taskTypeId">
                  <el-option v-for="item in workType" :key="`work-${item.id}`" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <el-select placeholder="Chọn trạng thái" v-model="filterForm.status">
                  <el-option v-for="item in status" :key="`status-${item.value}`" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select multiple collapse-tags placeholder="Chọn người giao việc" v-model="filterForm.assigners">
                  <el-option v-for="item in assigners" :key="`${item.UserId}`" :label="item.UserName"
                    :value="item.UserId">
                  </el-option>
                </el-select>
                <el-select placeholder="Chọn dự án" v-if="projectDetails.id === ''" v-model="filterForm.projectId">
                  <el-option v-for="(item, index) in myListProject" :key="`project-my-${item.id}-${index}`"
                    :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <div class="dateform">
                  <div class="row-flex time-picker">
                    <span class="title">Thời gian từ</span>
                    <el-date-picker v-model="filterForm.startDate" type="date" placeholder="" style="width:156px">
                    </el-date-picker>
                  </div>
                  <div class="row-flex time-picker">
                    <span class="title">đến</span>
                    <el-date-picker v-model="filterForm.endDate" type="date" placeholder="" style="width:156px">
                    </el-date-picker>
                  </div>
                </div>
                <div class="create-work">
                  <el-tooltip content="Tạo mới công việc" placement="top">
                    <el-button @click="openCreateWork" class="work-create">
                      <img src="/img/Add.svg" alt="Công việc" style="width: 24px; height: 24px" />
                    </el-button>
                  </el-tooltip>
                </div>
              </div>
              <!-- table data -->
              <div class="main-screen">
                <el-collapse>
                  <el-collapse-item v-if="projectDetails.id !== ''" v-for="(workItem, index) in tableData"
                    :key="workItem.TaskGrouId" :title="workItem.TaskGroupName" :name="index.toString()">

                    <el-table v-if="(workItem.ProjectTaskList || []).length > 0" :data="workItem.ProjectTaskList"
                      style="width: 100%">
                      <el-table-column type="index" label="STT" width="80" />
                      <el-table-column prop="ProjectTaskName" label="Tên công việc">
                        <template slot-scope="scope">
                          <span @click="handleDetails(scope.row)" style="color: #1E3CD7; cursor: pointer;"> {{
                            scope.row.ProjectTaskName }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="Type" label="Loại công việc" sortable />
                      <el-table-column prop="Status" label="Trạng thái" sortable>
                        <template slot-scope="scope">
                          <span>
                            {{ getStatusLabel(scope.row.Status) }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="AssignerName" label="Người giao việc" />
                      <el-table-column prop="StartDate" label="Thời gian bắt đầu" :formatter="formatDate"
                        align="center" />
                      <el-table-column prop="EndDate" label="Hạn hoàn thành" :formatter="formatDate" align="center" />

                      <el-table-column label="Hành động">
                        <template slot-scope="scope" class="action-button">
                          <div class="action-button">
                            <img src="/img/Expand.svg" @click="handleDetails(scope.row)"/>
                            <img src="/img/VB_ChoKyDuyet.svg" @click="handleDetails(scope.row)" />
                            <img src="/img/Delete.svg" @click="handleDelete(scope.row)" v-if="myProjectRole.Role === 'OWNER' || myProjectRole.Role === 'LEADER' || scope.row.AssignerId === myProjectRole.UserId " />
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- <div class="create-button" v-else>
                      <el-button @click="openCreateWork" class="work-create">
                        <img src="/img/Add.svg" alt="Công việc" style="width: 24px; height: 24px; margin-right: 10px" />
                        <span> Tạo mới công việc</span>
                      </el-button>
                    </div> -->
                  </el-collapse-item>

                  <el-collapse-item v-if="projectDetails.id === ''" v-for="workItem in tableData"
                    :key="`project-my-${workItem.ProjectId}`" :title="workItem.ProjectName">
                    <el-collapse>
                      <el-collapse-item v-for="(taskGroup, index) in workItem.TaskGroupList"
                        :key="`my-subtask-${taskGroup.TaskGroupId}-${index}`" :title="taskGroup.TaskGroupName"
                        :name="index.toString()">
                        <el-table :data="taskGroup.ProjectTaskList" style="width: 100%">
                          <el-table-column type="index" label="STT" width="80" />
                          <el-table-column prop="ProjectTaskName" label="Tên công việc">
                            <template slot-scope="scope">
                              <span @click="handleDetails({ row: scope.row, projectName: workItem.ProjectName })"
                                style="color: #1E3CD7; cursor: pointer;"> {{
                                scope.row.ProjectTaskName }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="Type" label="Loại công việc" sortable />
                          <el-table-column prop="Status" label="Trạng thái" sortable>
                            <template slot-scope="scope">
                              <span>
                                {{ getStatusLabel(scope.row.Status) }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="AssignerName" label="Người giao việc" />
                          <el-table-column prop="StartDate" label="Thời gian bắt đầu" :formatter="formatDate"
                            align="center" />
                          <el-table-column prop="EndDate" label="Hạn hoàn thành" :formatter="formatDate"
                            align="center" />
                          <el-table-column label="Hành động">
                            <template slot-scope="scope">
                              <div class="action-button">
                                <img src="/img/Expand.svg"
                                  @click="handleDetails({ row: scope.row, projectName: workItem.ProjectName })" />
                                <img src="/img/VB_ChoKyDuyet.svg"
                                  @click="handleDetails({ row: scope.row, projectName: workItem.ProjectName })" />
                                <img src="/img/Delete.svg" @click="handleDelete(scope.row)" />
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-collapse-item>
                    </el-collapse>
                  </el-collapse-item>

                </el-collapse>


              </div>
            </div>
            <div class="my-member-screen" v-if="tabs === 'member'">
              <div class="member-actions" v-if=" myProjectRole.Role === 'OWNER' && this.projectDetails.id !== ''">
                <button class="add-member-btn" @click="addMember()">+ Thêm thành viên vào dự án</button>
              </div>
              <!-- Danh sách thành viên -->
              <div v-for="member in listProjetMember" :key="member.id" class="member-card">
                <img :src="member.AvataImageId ? ExtensionService.urlImg + member.AvataImageId : 'img/user.png'"
                  alt="Avatar" class="avatar" />

                <div class="member-info">
                  <h3>{{ member.EmployeeNo }} - {{ member.UserFullName }} ({{ member.UserName }})</h3>
                  <p>{{ getRoleName(member.Role) }}</p>
                </div>

                <div class="member-buttons">
                  <button class="member-btn" @click="updateMember(member)" v-if="((myProjectRole.Role === 'OWNER' && member.UserId !== myProjectRole.UserId ) 
                    || (myProjectRole.Role === 'LEADER' && member.Role === 'MEMBER'))
                    && myProjectRole.Role !== 'MEMBER'">Cập nhật</button>
                  <button class="member-btn danger" @click="deleteMember(member)" v-if="myProjectRole.Role === 'OWNER' && member.UserId !== myProjectRole.UserId">Xóa khỏi dự án</button>
                </div>
              </div>

              <!-- Popup Thêm thành viên -->
              <div class="modal-overlay" v-if="showAddMemberModal" :class="{ active: showAddMemberModal }">
                <div class="modal-content">
                  <div class="modal-header">
                    <h3 class="modal-title">Thêm thành viên vào dự án</h3>
                    <button class="modal-close" @click="closeAddMemberModal">&times;</button>
                  </div>
                  <div class="modal-body">
                    <form @submit.prevent="submitAddMember">
                      <!-- Tìm kiếm thành viên - chỉ hiển thị khi chưa chọn thành viên -->
                      <div class="form-group" v-if="!selectedUser">
                        <label class="form-label">Tìm kiếm thành viên</label>
                        <div class="search-input-group">
                          <input type="text" class="form-control" v-model="searchTerm" placeholder="Nhập tên, mã nhân viên hoặc account"
                            @keyup.enter="searchMembers" />
                          <button type="button" class="search-btn" @click="searchMembers" :disabled="isSearching">
                            <span>Tìm kiếm</span>
                          </button>
                        </div>
                      </div>

                      <!-- Danh sách thành viên tìm được - chỉ hiển thị khi có kết quả tìm kiếm và chưa chọn thành viên -->
                      <div class="search-results" v-if="(searchResults || []).length > 0 && !selectedUser">
                        <div v-for="user in searchResults" :key="user.id" class="search-result-item"
                          @click="selectUser(user)">
                          <img :src="user.AvataImageId ? ExtensionService.urlImg + user.AvataImageId : 'img/user.png'"
                            alt="Avatar" class="avatar" />
                          <div class="user-info">
                            <h4>{{ user.EmployeeNo }} - {{ user.UserFullName }}</h4>
                            <p>{{ user.UserName }}</p>
                          </div>
                        </div>
                      </div>

                      <!-- Thông báo không tìm thấy kết quả -->
                      <div class="no-results"
                        v-if="(searchResults || []).length === 0 && searchTerm && isSearching && !selectedUser">
                        Không tìm thấy thành viên phù hợp
                      </div>

                      <!-- Thành viên đã chọn -->
                      <div class="form-group" v-if="selectedUser">
                        <label class="form-label">Thành viên đã chọn</label>
                        <div class="member-info-display">
                          <div class="avatar-preview">
                            <img
                              :src="selectedUser.AvataImageId ? ExtensionService.urlImg + selectedUser.AvataImageId : 'img/user.png'"
                              alt="Avatar" />
                          </div>
                          <div class="member-details">
                            <h4>{{ selectedUser.EmployeeNo }} - {{ selectedUser.UserFullName }}</h4>
                            <p>{{ selectedUser.UserName }}</p>
                          </div>
                          <!-- Nút X để hủy chọn thành viên -->
                          <button type="button" class="member-remove-btn" @click="unselectUser">&times;</button>
                        </div>
                      </div>

                      <!-- Vai trò trong dự án - chỉ hiển thị khi đã chọn thành viên -->
                      <div class="form-group" v-if="selectedUser">
                        <label class="form-label">Vai trò trong dự án</label>
                        <select class="form-control" v-model="newMember.role" required>
                          <option v-for="role in (roles || []).filter(data => data.id !== 'OWNER' )" :key="role.id" :value="role.id">
                            {{ role.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Chọn trưởng nhóm (chỉ hiện khi Role là LEADER) -->
                      <div class="form-group" v-if="newMember.role === 'MEMBER'">
                        <label class="form-label">Chọn trưởng nhóm</label>
                        <select class="form-control" v-model="newMember.leaderId" required>
                          <option disabled value="">-- Chọn một người --</option>
                          <option v-for="member in (listLeader || []).filter(data => data.UserId !== newMember.UserId)"
                            :key="member.UserId" :value="member.UserId">
                            {{ member.EmployeeNo }} - {{ member.UserFullName }} ({{ member.UserName }})
                          </option>
                        </select>
                      </div>

                    </form>
                  </div>
                  <div class="modal-footer">
                    <button class="modal-btn modal-btn-cancel" @click="closeAddMemberModal">Hủy</button>
                    <button class="modal-btn modal-btn-submit" @click="submitAddMember" :disabled="!canSubmitAdd">
                      Thêm thành viên
                    </button>
                  </div>
                </div>
              </div>

              <!-- Popup Cập nhật thành viên -->
              <div class="modal-overlay" v-if="showUpdateMemberModal" :class="{ active: showUpdateMemberModal }">
                <div class="modal-content">
                  <div class="modal-header">
                    <h3 class="modal-title">Cập nhật thành viên</h3>
                    <button class="modal-close" @click="closeUpdateMemberModal">&times;</button>
                  </div>
                  <div class="modal-body">
                    <form @submit.prevent="submitUpdateMember">
                      <!-- Thông tin thành viên -->
                      <div class="member-info-display">
                        <div class="avatar-preview">
                          <img
                            :src="memberToUpdate.AvataImageId ? ExtensionService.urlImg + memberToUpdate.AvataImageId : 'img/user.png'"
                            alt="Avatar" />
                        </div>
                        <div class="member-details">
                          <h4>{{ memberToUpdate.EmployeeNo }} - {{ memberToUpdate.UserFullName }}</h4>
                          <p>{{ memberToUpdate.UserName }}</p>
                        </div>
                      </div>

                      <!-- Vai trò trong dự án -->
                      <div class="form-group">
                        <label class="form-label">Vai trò trong dự án</label>
                        <select class="form-control" v-model="memberToUpdate.Role" required>
                          <option v-for="role in (roles || []).filter(data =>  {
                              if(myProjectRole.Role === 'OWNER'){
                                return data.id !== 'OWNER'
                              }
                              else{
                                return (data.id !== 'OWNER' && data.id !== 'LEADER')
                              }
                            } )" :key="role.id" :value="role.id">
                            {{ role.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Chọn trưởng nhóm (chỉ hiện khi Role là LEADER) -->
                      <div class="form-group" v-if="memberToUpdate.Role === 'MEMBER'">
                        <label class="form-label">Chọn trưởng nhóm</label>
                        <select class="form-control" v-model="memberToUpdate.LeaderId" required>
                          <option disabled value="">-- Chọn một người --</option>
                          <option
                            v-for="member in (listLeader || []).filter(data => data.UserId !== memberToUpdate.UserId)"
                            :key="member.UserId" :value="member.UserId">
                            {{ member.EmployeeNo }} - {{ member.UserFullName }} ({{ member.UserName }})
                          </option>
                        </select>
                      </div>

                    </form>
                  </div>
                  <div class="modal-footer">
                    <button class="modal-btn modal-btn-cancel" @click="closeUpdateMemberModal">Hủy</button>
                    <button class="modal-btn modal-btn-submit" @click="submitUpdateMember">Cập nhật</button>
                  </div>
                </div>
              </div>

              <!-- Popup xác nhận xóa thành viên (cập nhật lại theo thiết kế mới) -->
              <div class="modal-overlay" v-if="showConfirmDialog" :class="{ active: showConfirmDialog }">
                <div class="modal-content">
                  <div class="modal-header">
                    <h3 class="modal-title">Xác nhận xóa thành viên</h3>
                    <button class="modal-close" @click="cancelDelete">&times;</button>
                  </div>
                  <div class="modal-body">
                    <p>Bạn có chắc chắn muốn xóa thành viên <strong>{{ memberToDelete.UserFullName }}</strong> khỏi dự
                      án
                      không?</p>
                  </div>
                  <div class="modal-footer">
                    <button class="modal-btn modal-btn-cancel" @click="cancelDelete">Hủy</button>
                    <button class="modal-btn modal-btn-confirm" @click="confirmDelete">Xóa</button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <PopupDialog v-if="showPopup" title="" @close="closeDetailsPopup" @confirm="onConfirm">
      <div class="popup-content">
        <!-- tên dự án -->
        <span class="project-name ">{{ projectName }}</span>
        <p class="task-name ">{{ taskInfor.Name }}</p>
        <p class="last-change "> Thay đổi lần cuối {{ lastUpdateRelative }} bởi <span class="author ">{{
            userUpdateName }}</span> </p>
        <div class="assigner-list">
          <div class="assigner-item" style="background: transparent" @click="openAssign">
            <AvatarComponent :imageUrl="'/img/assign.svg'" :size="20" :text="'Assigner'" />
            <span class="assigner-member" v-if="(taskInfor.Assignee || []).length == 0">Giao việc </span>
          </div>

          <div class="assigner-item member" v-for="assigner in taskInfor.Assignee" :key="assigner.UserId">
            <AvatarComponent :imageUrl="ExtensionService.urlImg + assigner.AvataImageId" :size="20"
              :text="assigner.UserFullName" />
            <span class="assigner-member">{{ assigner.UserFullName }}</span>

            <button class="remove-btn" @click="removeAssignee(assigner)">×</button>
          </div>
        </div>
        <div class="task-type">
          <div class="task-element">
            <span>Phân loại </span>
            <el-select placeholder="Select" v-model="taskInfor.Type_id">
              <el-option v-for="item in (workType || []).filter(x => x.id !== '')" :key="`${item.id}`"
                :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="task-element">
            <span>Trạng thái </span>
            <el-select placeholder="Select" v-model="taskInfor.Status">
              <el-option v-for="item in (status || []).filter(x => x.value !== '')" :key="`${item.value}`"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="task-element">
            <span>Độ ưu tiên </span>
            <el-select placeholder="Select" v-model="taskInfor.Priority">
              <el-option v-for="item in (priority || []).filter(x => x.value !== '')" :key="`${item.value}`"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>


        </div>
        <div class="dateform">
          <div class="time-picker">
            <span class="title">Ngày bắt đầu </span>
            <el-date-picker type="date" placeholder="" style="width:180px" v-model="taskInfor.Start_date" />
          </div>
          <div class="time-picker">
            <span class="title">Ngày kết thúc</span>
            <el-date-picker type="date" placeholder="" style="width:180px" v-model="taskInfor.End_date" />
          </div>
        </div>
        <div class="note-form">
          <span class="title">Ghi chú </span>
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 20 }" v-model="taskInfor.Note"
            placeholder="Nhập ghi chú...">
          </el-input>
        </div>
        <div class="check-box-list">
          <div class="title" id="checklist-title">
            Danh sách kiểm tra ({{(taskInfor.Checklist || []).filter(data => data.Done === true).length
            }}/{{ (taskInfor.Checklist || []).length }})
          </div>

          <div class="checkbox-group">
            <div class="checkbox-item" v-for="(check, index) in taskInfor.Checklist" :key="index">
              <input type="checkbox" :id="'task-' + index" v-model="check.Done" />
              <label :for="'task-' + index" class="task-list">{{ index + 1 }}. {{ check.Item }}</label>
            </div>
            <div v-if="showNewTaskInput" class="checkbox-item">
              <el-input ref="newTaskInput" type="text" v-model="newTaskText" @keyup.enter.native="addChecklistItem"
                 placeholder="Nhập công việc..." />
              <el-button type="primary" @click="addChecklistItem">Tạo</el-button>
              <el-button @click="cancelAddChecklistItem">Hủy</el-button>
            </div>
            <div class="work-add" v-if="!showNewTaskInput" @click="showNewTaskInput = true">
              <span>+ Thêm công việc</span>
            </div>
          </div>
        </div>

        <div class="file-wrapper">
          <h4><strong>Tệp đính kèm</strong></h4>
          <div class="file-item" v-for="fileItem in taskInfor.Mushroom_file" :key="fileItem.FileId">
            <img src="/img/excel-dinh-kem.svg" alt="excel" style="width: 16px; height: 16px;"
              v-if="fileItem.Extension == '.xlxs' || fileItem.Extension == '.xls' || fileItem.Extension == '.xlx'" />
            <img src="/img/word-dinh-kem.svg" alt="word" style="width: 16px; height: 16px;"
              v-if="fileItem.Extension == '.docs' || fileItem.Extension == '.docx' || fileItem.Extension == '.doc'" />
            <img src="/img/pdf-dinh-kem.svg" alt="pdf" style="width: 16px; height: 16px;"
              v-if="fileItem.Extension == '.pdf'" />
            <img src="/img/file-dinh-kem.svg" alt="pdf" style="width: 16px; height: 16px;" v-else />
            <a :href="getFileDownloadLink(fileItem)" target="_blank" class="file-name-truncate"
              :title="fileItem.FileName" download>{{ fileItem.FileName }}</a>
            <img src="/img/tai-xuong.svg" alt="Ghim" style="width: 16px; height: 16px; margin-right: 6px;" />
          </div>
          <div class="upload-file" @click="triggerFileInput">
            <span>+ Thêm tệp đính kèm</span>
          </div>
          <input type="file" ref="fileInput" multiple style="display: none" @change="handleFileUpload" />
        </div>


      </div>

    </PopupDialog>
    <PopupDialog v-if="showAssignPopup" title="Thêm người đảm nhiệm" @close="closeAssign" @confirm="confirmAssign">
      <div class="assign-content">
        <el-autocomplete popper-class="my-autocomplete" v-model="searchAssign" :fetch-suggestions="querySearch"
          placeholder="Tìm người đảm nhiệm" @select="handleSelectAssigner">
          <template slot-scope="{ item }">
            <div class="sugesstion">
              <img :src="item.AvataImageId ? ExtensionService.urlImg + item.AvataImageId : 'img/user.png'"
                class="avatar" />
              <div class="infor">
                <div class="value">{{ item.UserFullName }}</div>
                <span class="link">{{ item.EmployeeNo }}</span>
              </div>
            </div>
          </template>
        </el-autocomplete>

        <el-table :data="selectedAssignees" ref="assignTable" class="no-header-table"
          @selection-change="handleSelectionChange" style="margin-top: 16px">
          <el-table-column type="selection" width="50"></el-table-column>

          <el-table-column>
            <template slot-scope="{ row }">
              <div class="sugesstion">
                <img :src="row.AvataImageId ? ExtensionService.urlImg + row.AvataImageId : 'img/user.png'"
                  class="avatar" />
                <div class="infor">
                  <div class="value">{{ row.UserFullName }}</div>
                  <span class="link">{{ row.EmployeeNo }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="Role" width="120"></el-table-column>
        </el-table>


      </div>
    </PopupDialog>

    <PopupDialog v-if="showDeletePopup" title="" @close="closeDeletePopup" @confirm="confirmDeletedTask">
      <div class="popup-content-delete">
        <p>Bạn có chắc chắn muốn xóa?</p>
      </div>
    </PopupDialog>
    <PopupDialog
      v-if="showCreateWork"
      @confirm="onConfirmCreateWork"
      title="Thêm công việc"
      @close="closeCreateWork"
    >
          <div class="create-work-content">
          <div class="work-name">
            <span class="title">Tên {{taskWorkType === '2'?'Công việc' :'Nhóm'}} <span class="required">*</span> </span>
            <el-input  
              v-model="workCreate.name"  :class="['create-work-placeholder-field', { 'is-error': errors.name }]"
              placeholder="Nhập tên công việc">
            </el-input>
             <div v-if="errors.name" class="error">{{errors.name }}</div>
          </div>
          <div class="task-type">
            <div class="task-element">
              <span>Dự án <span class="required">*</span> </span>
              <el-select placeholder="Chọn dự án" v-model="workCreate.project_id"  :class="['create-work-placeholder-field', { 'is-error': errors.project_id }]">
                <el-option v-for="item in listProject " :key="`${item.id}type`"
                  :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <div v-if="errors.project_id" class="error">{{ errors.project_id }}</div>
          </div>
            <div class="task-element">
              <span>Loại công việc <span class="required">*</span>  </span>
                  <div class="radio-element">
                    <el-radio v-model="taskWorkType" label="1" :value="1" :disabled="!workCreate.project_id">Nhóm công việc</el-radio>
                    <el-radio v-model="taskWorkType" label="2" :value="2" :disabled="!workCreate.project_id">Công việc</el-radio>
                </div>
          </div>
           <div class="task-element" v-if="taskWorkType === '2'">
              <span>Nhóm công việc<span class="required">*</span> </span>
              <el-select placeholder="Chọn nhóm công việc" v-model="workCreate.task_group_id" :class="['create-work-placeholder-field', { 'is-error': errors.task_group_id }]" :disabled="!workCreate.project_id">
                <el-option v-for="item in taskGroup " :key="`${item.id}`"
                  :label="item.name" :value="item.id">
                </el-option>
            </el-select>  
            <div v-if="errors.task_group_id" class="error">{{ errors.task_group_id }}</div>
          </div>
          </div>
           <div class="task-type" v-if="taskWorkType === '2'">
          
          <div class="task-element">
            <span>Phân loại <span class="required">*</span> </span>
            <el-select placeholder="Chọn phân loại" v-model="workCreate.type_id"   :class="['create-work-placeholder-field', { 'is-error': errors.type_id }]" :disabled="!workCreate.project_id">
               <el-option v-for="item in (workType || []).filter(x => x.id !== '')" :key="`${item.id}`"
                :label="item.name" :value="item.id">
              </el-option>
            </el-select>
              <div v-if="errors.type_id" class="error">{{ errors.type_id }}</div>
          </div>
          <div class="task-element">
            <span>Trạng thái <span class="required">*</span> </span>
            <el-select placeholder="Chọn Trạng thái" v-model="workCreate.status"  :class="{ 'is-error': errors.status }"  :disabled="!workCreate.project_id">
              <el-option  v-for="item in (status || []).filter(x => x.value !== '')" :key="`${item.value}`"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div v-if="errors.status" class="error">{{ errors.status }}</div>
          </div>
          <div class="task-element">
            <span>Độ ưu tiên <span class="required">*</span> </span>
            <el-select placeholder="Chọn độ ưu tiên" v-model="workCreate.priority"  :class="{ 'is-error': errors.priority }" :disabled="!workCreate.project_id" >
              <el-option v-for="item in (priority || []).filter(x => x.value !== '')" :key="`${item.value}`"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
             <div v-if="errors.priority" class="error">{{ errors.priority }}</div>
          </div>


        </div>
        <div class="dateform" v-if="taskWorkType === '2'">
          <div class="time-picker">
            <span class="title">Ngày bắt đầu</span>
            <el-date-picker type="date" placeholder="" v-model="workCreate.start_date" style="width:180px;"  :disabled="!workCreate.project_id"/>
          </div>
          <div class="time-picker">
            <span class="title">Ngày kết thúc</span>
            <el-date-picker type="date" placeholder="" v-model="workCreate.end_date" style="width:180px;"   :disabled="!workCreate.project_id"/>
          </div>
        </div>
        <div class="note-form" v-if="taskWorkType === '2'">
          <span class="title">Ghi chú </span>
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 20 }" 
            placeholder="Nhập ghi chú..."
            v-model="workCreate.note"
              :disabled="!workCreate.project_id">
          </el-input>
        </div>
          </div>
    </PopupDialog>

    <div class="popupDialog">
      <PopupDialog   v-if="showAddProjet" @confirm="onConfirmCreateProject" title="Thêm dự án" @close="closeCreateProject">
          <div class="create-project-content">
            <div class="project-name">
              <span class="title">Tên dự án</span>
              <el-input  
                v-model="projectCreate.name"
                class="create-project-input"
                @keyup.enter.native="onConfirmCreateProject"
                placeholder="Nhập tên dự án">
              </el-input>
           </div>
          </div>
      </PopupDialog>
      <PopupDialog   v-if="showUpdateProjet" @confirm="onConfirmUpdateProject" title="Cập nhật dự án" @close="closeUpdateProject">
          <div class="create-project-content">
            <div class="project-name">
              <span class="title">Tên dự án</span>
              <el-input  
                v-model="projectUpdate.name"
                class="create-project-input"
                placeholder="Nhập tên dự án">
              </el-input>
           </div>
          </div>
      </PopupDialog>
    </div>
  </div>
</template>

<script>


import ProjectApi from "@/moduleApi/ProjectApi";
import PinnedProjectApi from "@/moduleApi/PinnedProjectApi";
import ProjectTaskApi from "@/moduleApi/ProjectTaskApi";
import ProjectMemberApi from "@/moduleApi/ProjectMemberApi";
import TaskGroupApi from "@/moduleApi/TaskGroupApi";

import ExtensionService from "../../../service/ExtensionService";
import TypeTaskApi from "@/moduleApi/TypeTaskApi";

import MethodService from "@/service/MethodService";
import { WORK_STATUS, PRIORITY } from "@/const/constant";
import PopupDialog from "../../../component/Popup/PopupDialog.vue";

import AvatarComponent from "../../../component/Avatar/AvatarComponent.vue";

import TooltipMenu from "../../../component/AssignWork/TooltipMenu.vue";


export default {
  name: "AssignWork",
  components: {
    AvatarComponent,
    PopupDialog,
    TooltipMenu
  },
  data() {
    return {
      errors: {},
      workCreate: {
         status: WORK_STATUS[1].value,
        priority: PRIORITY[0].value,
      },
      taskGroup: [],
      taskWorkType: '1',
      showCreateWork: false,
      searchAssign: '',
      selectedAssignees: [],
      assigneNewMember: [],
      showAssignPopup: false,
      assigneListAdd: [],
      showNewTaskInput: false,
      newTaskText: '',
      mode: 'show',
      ExtensionService,
      taskInfor: {},
      files: [],
      showPopup: false,
      showDeletePopup: false,
      projectName: '',
      tableData: [],
      currentUser: MethodService.getCurrentUser(),
      currentCompany: MethodService.getCompanyInfo(),
      activeMenu: '',
      minisizeSubNav: false,
      projectDetails: {
        id: "",
        name: 'Công việc của tôi'
      },
      filterForm: {
        taskTypeId: '',
        status: WORK_STATUS[0].value,
        assigners: [],
        startDate: '',
        endDate: '',
        projectId: ''
      },
      workList: [],
      workType: [
        {
          id: '',
          name: 'Tất cả loại công việc'
        }
      ],
      status: WORK_STATUS,
      priority: PRIORITY,
      assigners: [

      ],
      tabs: 'work',
      formFilter: {},
      links: "",
      target: "/",
      navSub: [],
      showSubNav: true,
      listProjectPind: [],
      listProject: [],
      listFileUpload: [],
      listProjetMember: [],
      showConfirmDialog: false,
      memberToDelete: null,
      showUpdateMemberModal: false,
      memberToUpdate: null,
      showAddMemberModal: false,
      taskIdDeleted: '',
      roles: [
        { "id": "OWNER", "name": "Trưởng dư án" },
        { "id": "LEADER", "name": "Trưởng nhóm" },
        { "id": "MEMBER", "name": "Thành Viên" },
      ],
      listLeader: [],
      myListProject: [],
      searchTerm: '',
      searchResults: [],
      selectedUser: null,
      newMember: {},
      isSearching: false,
      myProjectRole:{},
      showAddProjet: false,
      projectCreate:[],
      showUpdateProjet: false,
      projectUpdate:[],
    };
  },
  watch: {
    'workCreate.project_id'(newVal) {
      if (newVal) {
        this.loadTaskGroup();
      }
    },
    filterForm: {
      handler() {
        this.search();
      },
      deep: true
    }
  },
  computed: {
    userUpdateName() {
      if (this.taskInfor && this.taskInfor.UserUpdate) {
        return this.taskInfor.UserUpdate.UserFullName;
      }
      return '';
    },
    lastUpdateRelative() {
      const updatedAt = new Date(this.taskInfor.Updated_at);
      const now = new Date();
      const diffMs = now - updatedAt;
      const diffMinutes = Math.floor(diffMs / 60000);

      if (diffMinutes < 60) {
        return `${diffMinutes} phút trước`;
      }
      const diffHours = Math.floor(diffMinutes / 60);
      if (diffHours < 24) {
        return `${diffHours} giờ trước`;
      }
      const diffDays = Math.floor(diffHours / 24);
      return `${diffDays} ngày trước`;
    },

    canSubmitAdd() {
      return this.selectedUser && this.newMember.role;
    },
    projectMenuDefaultOpeneds() {
      const openeds = [];
      if ((this.listProjectPind || []).length > 0) {
        openeds.push('1');
      }
      if ((this.listProject || []).length > 0) {
        openeds.push('2');
      }
      return openeds;
    }
  },
  methods: {
    ensureProjectMenusOpen() {
      this.$nextTick(() => {
        if (this.$refs.projectMenu && this.$refs.projectMenu.open) {
          if ((this.listProjectPind || []).length > 0) {
            this.$refs.projectMenu.open('1');
          }
          if ((this.listProject || []).length > 0) {
            this.$refs.projectMenu.open('2');
          }
        }
      });
    },
    handleProjectMenuClose(index) {
      if (
        (index === '1' && (this.listProjectPind || []).length > 0) ||
        (index === '2' && (this.listProject || []).length > 0)
      ) {
        this.ensureProjectMenusOpen();
      }
    },
    search(){
       if (this.projectDetails.id === '') {

          this.getAllMyTasks();

        } else {
          this.loadProjectDetails();
        }
    },
    async loadTaskGroup(){
     const res = await TaskGroupApi.list(
       {
        filters:`project_id=${this.workCreate.project_id}`,
         limit: 9999,
       }
     );
     this.taskGroup = res.result;
    },
    removeAssignee(val) {
      const userId = val.UserId;
      this.taskInfor.Assignee = this.taskInfor.Assignee.filter(
        assigner => assigner.UserId !== userId
      );
    },
    handleSelectionChange(val) {
      this.assigneNewMember = val;
    },
    handleSelectAssigner(user) {
      const exists = this.selectedAssignees.some(u => u.UserId === user.UserId);
      if (!exists) {
        this.selectedAssignees.push(user);
      }

      this.$nextTick(() => {
        const table = this.$refs.assignTable;
        table.clearSelection();
        this.selectedAssignees.forEach(u => {
          const found = this.assigneListAdd.find(item => item.UserId === u.UserId);
          if (found) {
            table.toggleRowSelection(found, true);
          }
        });
      });
    },
    querySearch(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      const results = this.assigneListAdd.filter(user => {
        const lowerQuery = queryString.toLowerCase();
        return (
          (user.UserName && user.UserName.toLowerCase().includes(lowerQuery)) ||
          (user.EmployeeNo && user.EmployeeNo.toLowerCase().includes(lowerQuery))
        );
      });
      cb(results);
    },
    closeAssign() {
      this.assigneListAdd = [];
      this.assigneNewMember = [];
      this.selectedAssignees = [];
      this.searchAssign = '';
      this.showAssignPopup = false;
    },
    confirmAssign() {
      const oldAssignees = this.taskInfor.Assignee || [];
      const newAssignees = this.assigneNewMember || [];

      const newOnly = newAssignees.filter(newUser => {
        return !oldAssignees.some(oldUser => oldUser.UserId === newUser.UserId);
      });
      this.taskInfor.Assignee.push(...newOnly);
      this.assigneListAdd = [];
      this.assigneNewMember = [];
      this.selectedAssignees = [];
      this.searchAssign = '';
      this.showAssignPopup = false;
    },
    async openAssign() {
      const res = await ProjectMemberApi.GetProjectMembers({
        ProjectId: this.taskInfor.Project_id
      });
      this.assigneListAdd = res.result.ProjectMembers;
      this.showAssignPopup = true;
    },
    openNewTaskInput() {
      this.showNewTaskInput = true;
      this.$nextTick(() => {
        this.$refs.newTaskInput.focus();
      });
    },
    addChecklistItem() {
      console.log("abd");
      const text = this.newTaskText.trim();
      if (text) {
        if(!this.taskInfor.Checklist || this.taskInfor.Checklist.length === 0){
          this.taskInfor.Checklist =[];
        }
        this.taskInfor.Checklist.push({ Item: text, Done: false });
      }

      this.newTaskText = '';
      this.showNewTaskInput = false;
    },
    cancelAddChecklistItem() {
      this.newTaskText = '';
      this.showNewTaskInput = false;
    },
   
    closeDeletePopup() {
      this.taskIdDeleted = '';
      this.showDeletePopup = false;
    },
    async confirmDeletedTask() {
      await ProjectTaskApi.delete(this.taskIdDeleted);
      this.showDeletePopup = false;
      if (this.projectDetails.id === '') {

        this.getAllMyTasks();

      } else {
        this.loadProjectDetails();
      }
    },
    formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      const date = new Date(cellValue);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}-${month}-${year}`;
    },
    handleDelete(value) {
      this.taskIdDeleted = value.ProjectTaskId;
      this.showDeletePopup = true;
    },
    openCreateWork() {
      this.showCreateWork = true;

    },
    validation() {
      this.errors = {};
      if (!this.workCreate.name) {
        this.errors.name = 'Tên công việc là bắt buộc'; 
      }
      if (!this.workCreate.project_id) {
        this.errors.project_id = 'Dự án là bắt buộc';
      }
  
      if (this.taskWorkType === '2') {
        if (!this.workCreate.task_group_id) {
          this.errors.task_group_id = 'Nhóm công việc là bắt buộc';
        }
        if (!this.workCreate.type_id) {
          this.errors.type_id = 'Phân loại là bắt buộc';
        }
        if (!this.workCreate.status) {
          this.errors.status = 'Trạng thái là bắt buộc';
        }
        if (!this.workCreate.priority) {
          this.errors.priority = 'Độ ưu tiên là bắt buộc';
        }
      }
 
    },
    async onConfirmCreateWork() {
      this.validation();
      if (Object.keys(this.errors).length > 0) {
        return;
      }
      const createdWorkProjectId = this.workCreate.project_id;
      if (this.taskWorkType === '2') {
        this.workCreate.assigner_id = this.currentUser.id;
        this.workCreate.user_update_id = this.currentUser.id;
        this.workCreate.assignee = [];
        this.workCreate.updated_at = new Date();

        await ProjectTaskApi.create(this.workCreate);
      } else {
      await TaskGroupApi.create(this.workCreate);
    }

    this.closeCreateWork();
    this.openProjectAfterCreateWork(createdWorkProjectId);

  },
 

 
    closeCreateWork() {
      this.workCreate = {
        status: WORK_STATUS[1].value,
        priority: PRIORITY[0].value,
      };
      this.showCreateWork = false;
      this.errors = {};
      this.taskWorkType = '1';
      
     
    },
    openProjectAfterCreateWork(projectId) {
      if (!projectId) {
        this.search();
        return;
      }
      this.tabs = 'work';
      this.handleMenuSelect(`project-${projectId}`);
    },
    async onConfirm() {
      if (this.mode === 'show') {
        const dataUpdate = {
          id: this.taskInfor.Id,
          project_id: this.taskInfor.Project_id,
          task_group_id: this.taskInfor.Task_group_id,
          name: this.taskInfor.Name,
          type_id: this.taskInfor.Type_id,
          status: this.taskInfor.Status,
          priority: this.taskInfor.Priority,
          assignee_id: this.taskInfor.Assignee.map(e => e.UserId),
          assigneer_id: this.taskInfor.Assigner.UserId,
          start_date: this.taskInfor.Start_date,
          end_date: this.taskInfor.End_date,
          note: this.taskInfor.Note,
          checklist: this.taskInfor.Checklist
            ? this.taskInfor.Checklist.map(function (item) {
              return {
                item: item.Item,
                done: item.Done
              };
            })
            : [],
          user_update_id: this.currentUser.id,
          updated_at: new Date(),
          mushroom_file: [...this.taskInfor.Mushroom_file.filter(file => file.FileId).map(file => file.FileId)]
        };

        const filesToUpload = this.listFileUpload;

        for (const file of filesToUpload) {
          try {
            const res = await ExtensionService.upload({ raw: file, name: file.name }, 'task_file');
            file.FileId = res.result;
          } catch (error) {
            return;
          }
        }
        const newFileIds = filesToUpload.map(e => e.FileId);

        dataUpdate.mushroom_file.push(...newFileIds);

        await ProjectTaskApi.update(dataUpdate);
      }
    },

    closeDetailsPopup() {
      this.showPopup = false;
      this.mode = '';
      this.taskInfor = {};
      this.listFileUpload = [];
    },
    getFileDownloadLink(fileItem) {
      if (fileItem.FileId) {
        return ExtensionService.urlDowloadFile + fileItem.FileId;
      } else if (fileItem.raw) {
        return URL.createObjectURL(fileItem.raw); // tạo đường dẫn tạm
      }
      return '#';
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      if (!this.taskInfor.Mushroom_file) {
        this.$set(this.taskInfor, 'Mushroom_file', []);
      }
      this.listFileUpload = files;
      this.listFileUpload.forEach(file => {
        this.taskInfor.Mushroom_file.push({
          raw: file,
          Extension: `.${file.name.split('.').pop().toLowerCase()}`,
          FileName: file.name
        })
      })
      event.target.value = '';

    },
    async handleDetails(value) {
      this.showPopup = true;
      this.mode = 'show';
      const taskId = this.projectDetails.id === '' ? value.row.ProjectTaskId : value.ProjectTaskId;
      if (this.projectDetails.id === '') {
        this.projectName = value.projectName;
      } else {
        this.projectName = this.projectDetails.name;
      }
      const res = await ProjectTaskApi.GetProjectTaskDetail({
        ProjectTaskId: taskId
      });
      if (res.result) {
        this.taskInfor = res.result.ProjectTask;

      }
    },
    getStatusLabel(value) {
      const status = WORK_STATUS.find(item => {
        if (item.value == value)
          return item
      });
      return status ? status.label : '';
    },
    async loadTaskType() {
      const resultTaskType = await TypeTaskApi.list({
        filters: "company_id=" + this.currentCompany.id,
        limit: 9999999,
        sort: "name",
        fields: "id,name",
      });
      if (resultTaskType.result) {
        this.workType = this.workType = [{
          id: '',
          name: 'Tất cả loại công việc'
        }, ...resultTaskType.result];
      }
      await this.loadProjectMembers();
    },
    async loadProjectDetails() {
      const assignerUserIds = this.filterForm.assigners
        .filter(a => a && a !== '')
        .map(a => a);
      this.loadTaskType();
      this.loadAssignee();
      const res = await ProjectApi.GetProjectDetails({
        "ProjectId": this.projectDetails.id,
        "IsFilter": true,
        "FilterData": {
          "TypeTaskId": this.filterForm.taskTypeId,
          "Status": this.filterForm.status,
          AssignerID: assignerUserIds,
          "From": this.filterForm.startDate,
          "To": this.filterForm.endDate,
        }
      });
      if(res.result.TaskGroupList.length != 0){
        this.tableData = res.result.TaskGroupList;
      }
      else{
        this.tableData = null;
      }

    },
    async loadAssignee() {
      if (this.projectDetails.id === '') {
        const res = await ProjectMemberApi.GetTaskAssigners({
          ProjectId: this.filterForm.projectId
        });


        if (res.result) {
          const filteredMembers = res.result.AssignerList.filter(
            member =>
              member.UserId !== this.currentUser.id && member.UserId !== ''
          );

          this.assigners = [
            {
              UserId: this.currentUser.id,
              UserName: 'Tôi'
            },
            {
              UserId: '',
              UserName: 'Tất cả'
            },
            ...filteredMembers
          ];
        }
      }
      else {
        const res = await ProjectMemberApi.GetProjectMembers({
          ProjectId: this.filterForm.projectId
        });
        if (res.result) {
          const filteredMembers = res.result.ProjectMembers.filter(
            member =>
              member.UserId !== this.currentUser.id && member.UserId !== ''
          );
          this.assigners = [
            {
              UserId: this.currentUser.id,
              UserName: 'Tôi'
            },
            {
              UserId: '',
              UserName: 'Tất cả'
            },
            ...filteredMembers
          ];
        }
      }

    },
   
    handleTabs(tab, event) {
      this.tabs = tab.name;
      switch (tab.name) {
        case 'work':

          break;

        case 'member':
          break;

        case 'statistical':
          break;

        default:
          console.warn('Tab không xác định:', tab.name);
      }
    },
    async handlePin(projectId) {
      const projectToPin = this.listProject.find(project => project.id == projectId);
      if (projectToPin && !this.listProjectPind.some(project => project.id == projectId)) {
        const resCreate = await PinnedProjectApi.create({
          project_id: projectId,
          user_id: this.currentUser.id
        });
        if (resCreate.result) {
          projectToPin.pinnedId = resCreate.result;
          this.listProjectPind.push(projectToPin);
          this.$notify.success({
            message: `Ghim thành công`,
            duration: 3000,
            customClass: "doc-success",
          });
        }
      } else {
        this.$notify.success({
          message: `Dự án đã có trong ghim`,
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },
    async handleUnPin(pinnedId) {
      const resDelete = await PinnedProjectApi.delete(pinnedId);
      if (resDelete.result > 0) {
        this.listProjectPind = (this.listProjectPind || []).filter(project => project.pinnedId != pinnedId);
        this.$notify.success({
          message: `Bỏ ghim Thành công`,
          duration: 3000,
          customClass: "doc-success",
        });
      }
      else {
        this.$notify.error({
          message: `Bỏ ghim thất bại`,
          duration: 3000,
          customClass: "doc-warning",
        });
      }

    },
    async projectLoaded() {
      const res = await ProjectApi.GetMyProjects();

      if (res.result) {
        this.listProject = res.result.ProjectsList;
        if (this.projectDetails.id === '') {
          this.myListProject = [{
            id: '',
            name: 'Tất cả dự án'
          },
          ...this.listProject
          ];
        }
        
        // this.listProjectPind = this.listProjectPind && this.listProjectPind.length > 0 ? this.listProjectPind.map(pinned => {
        //   let matchingProject = this.listProject.find(project => project.id === pinned.project_id);
        //   return matchingProject || null;
        // }).filter(project => project !== null) : [];

        let pinnedProjectList = res.result.PinnedProjectList;
        this.listProjectPind = pinnedProjectList && pinnedProjectList.length > 0 ? pinnedProjectList.map(pinned => {
          let data = this.listProject.find(project => project.id = pinned.project_id);
          if (data) {
            data.pinnedId = pinned.id;
            return data;
          }
          return null;
        }).filter(item => item !== null) : [];
        this.ensureProjectMenusOpen();
      }
    },
    async initData() {
      try {
        await this.projectLoaded();
        if (this.projectDetails.id === '') {
          this.getAllMyTasks();
        }
      } catch (error) {
        //
      }
    },
    async getAllMyTasks() {
      const assignerUserIds = (this.filterForm.assigners || [])
        .filter(a => a && a !== '')
        .map(a => a);
      const res = await ProjectApi.GetAllMyTasks({
        IsFilter: true,
        "FilterData": {
          "ProjectId": this.filterForm.projectId,
          "TypeTaskId": this.filterForm.taskTypeId,
          "Status": this.filterForm.status,
          AssignerID: assignerUserIds,
          "From": this.filterForm.startDate,
          "To": this.filterForm.endDate,
        }
      });
      this.tableData = res.result.MyProjectDto;
      this.loadTaskType();
      this.loadAssignee();

    },
    handleMenuSelect(index) {
      if(index === "add-project"){
        return
      }
      this.activeMenu = index;
      if (index == '') {
        this.projectDetails = {
          id: '',
          name: "Công việc của tôi"
        }
        this.filterForm = {
          taskTypeId: '',
          status: WORK_STATUS[0].value,
          assigners: [],
          startDate: '',
          endDate: '',
          projectId: ''
        }
        return;
      } else if (index.startsWith('pinned-')) {
        const id = index.replace('pinned-', '');
        const project = this.listProjectPind.find(p => p.id == id);
        if (!project) {
          return;
        }
        this.projectDetails = project;
        this.filterForm = {
          taskTypeId: '',
          status: WORK_STATUS[0].value,
          assigners: [],
          startDate: '',
          endDate: '',
          projectId: project.id
        }
        this.workCreate.project_id = project.id;
      } else if (index.startsWith('project-')) {
        const id = index.replace('project-', '');
        const project = this.listProject.find(p => p.id == id);
        if (!project) {
          return;
        }
        this.projectDetails = project;
        this.filterForm = {
          taskTypeId: '',
          status: WORK_STATUS[0].value,
          assigners: [],
          startDate: '',
          endDate: '',
          projectId: id
        }
        this.workCreate.project_id =id;
      }
      this.loadProjectDetails();

    },

    cancelDelete() {
      this.showConfirmDialog = false;
      this.memberToDelete = null;
    },

    deleteMember(member) {
      this.memberToDelete = member;
      this.showConfirmDialog = true;
    },
    async confirmDelete() {
      if (this.memberToDelete) {
        const resultDeleteMember = await ProjectMemberApi.delete(this.memberToDelete.Id);
        if (resultDeleteMember.result) {
          // Sau khi xóa thành công, cập nhật danh sách
          this.listProjetMember = (this.listProjetMember || []).filter(
            member => member.Id !== this.memberToDelete.Id
          );
          // Đóng popup
          this.showConfirmDialog = false;
          this.memberToDelete = null;
        }

      }
    },

    closeUpdateMemberModal() {
      this.showUpdateMemberModal = false;
      this.memberToUpdate = null;
    },

    updateMember(member) {
      this.memberToUpdate = { ...member };
      this.showUpdateMemberModal = true;
    },

    async submitUpdateMember() {
      var data = {
        id: this.memberToUpdate.Id,
        project_id: this.projectDetails.id,
        user_id: this.memberToUpdate.UserId,
        role: this.memberToUpdate.Role,
        leader_id: this.memberToUpdate.Role !== 'MEMBER' ? null : this.memberToUpdate.LeaderId,
      }
      if (this.memberToUpdate.Role !== 'MEMBER') {
        this.memberToUpdate.LeaderId = null;
      }
      const resultUpdateMember = await ProjectMemberApi.update(data);
      if (resultUpdateMember.result) {
        const index = this.listProjetMember.findIndex(data => data.Id === this.memberToUpdate.Id);
        if (index !== -1) {
          this.listProjetMember[index] = this.memberToUpdate;
        }
        await this.loadProjectMembers();
        this.showUpdateMemberModal = false;
        this.memberToUpdate = null;
      }

    },
    getRoleName(roleId) {
      const role = this.roles.find(r => r.id === roleId);
      return role ? role.name : 'Không rõ';
    },
    addMember() {
      this.showAddMemberModal = true;
      this.memberToAdd = null;
    },

    // btn-add member
    // Mở modal thêm thành viên
    openAddMemberModal() {
      this.showAddMemberModal = true;
      this.resetAddMemberForm();
    },

    // Đóng modal thêm thành viên
    closeAddMemberModal() {
      this.showAddMemberModal = false;
      this.resetAddMemberForm();
    },

    // Reset form thêm thành viên
    resetAddMemberForm() {
      this.searchTerm = '';
      this.searchResults = [];
      this.selectedUser = null;
      this.newMember = {
        userId: null,
        role: ''
      };
    },

    // Tìm kiếm thành viên
    searchMembers() {
      if (!this.searchTerm.trim()) return;

      // Gọi API tìm kiếm thành viên
      ProjectMemberApi.GetMembers({
        SearchTerm: this.searchTerm
      })
        .then(response => {
          const userIds = this.listProjetMember.map(member => member.UserId);

          this.isSearching = false;
          this.searchResults = response.result.filter(data => !userIds.includes(data.UserId));
          if (this.searchResults.length === 0) {
            this.isSearching = true;
          }
        })
        .catch(error => {
          console.error('Lỗi khi tìm kiếm thành viên:', error);
        })
        .finally(() => {
        });
    },

    // Chọn thành viên từ kết quả tìm kiếm
    selectUser(user) {
      this.selectedUser = user;
      this.newMember.userId = user.UserId;

    },

    // Hủy chọn thành viên
    unselectUser() {
      this.selectedUser = null;
      this.newMember = {};
    },
    async loadProjectMembers() {
      const resultProjectMem = await ProjectMemberApi.GetProjectMembers({
        "ProjectId": this.projectDetails.id,
      });
      if (resultProjectMem.result) {
        this.listProjetMember = resultProjectMem.result.ProjectMembers;
        this.listLeader = (this.listProjetMember || []).filter(data => data.Role === 'LEADER');
        console.log(this.listLeader);
      }
      if(this.listProjetMember && this.listProjetMember.length > 0){
        this.myProjectRole = this.listProjetMember.find(data => data.UserId === this.currentUser.id);
      }
      
    },
    // Submit form thêm thành viên
    submitAddMember() {
      if (!this.canSubmitAdd) return;

      // Gọi API thêm thành viên vào dự án
      let data = {
        project_id: this.projectDetails.id,
        user_id: this.newMember.userId,
        role: this.newMember.role,
        leader_id: this.newMember.leaderId,
      }
      ProjectMemberApi.create(data)
        .then(response => {
          this.loadProjectMembers(); // Tải lại danh sách thành viên
          this.closeAddMemberModal();
        })
        .catch(error => {
          console.error('Lỗi khi thêm thành viên:', error);
          this.$toast.error('Có lỗi xảy ra khi thêm thành viên');
        });
    },

    //----------------------------
    handleAddProject(){
      this.showAddProjet = true;
    },
    
    closeCreateProject(){
      this.showAddProjet = false;
      this.projectCreate ={};
    },

    async onConfirmCreateProject(){
      const projectName = (this.projectCreate.name || '').trim();
      if (!projectName) {
        return;
      }
      const dataRes = await ProjectApi.create({
        name: projectName,
        company_id: this.currentCompany.id,
        createdAt: new Date(),
      })
      if(dataRes.result){
        let data = {
        project_id: dataRes.result,
        user_id: this.currentUser.id,
        role: 'OWNER',
        }
        await ProjectMemberApi.create(data);
        await this.projectLoaded();
        this.closeCreateProject();
      }
    },

    closeUpdateProject(){
      this.showUpdateProjet = false;
      this.projectUpdate = [];
    },

    async onConfirmUpdateProject(){
      console.log(this.projectUpdate);
      const body ={
        id: this.projectUpdate.id,
        name: this.projectUpdate.name,
      };
      const dataRes =  await ProjectApi.update(body)

      if(dataRes.result){
        if(this.projectDetails.id === ''){
          await this.initData();
        }
        else{
          await this.projectLoaded();
          if(this.projectDetails.id === body.id){
            this.projectDetails.name = body.name;
          }
        }
      }
      this.projectUpdate = [];
    },
    handleUpdateProject(project) {
      this.showUpdateProjet = true;
      this.projectUpdate = { ...project }
      // this.$confirm('Bạn có muốn cập nhật dự án này không?', 'Xác nhận', {
      //   confirmButtonText: 'Có',
      //   cancelButtonText: 'Không',
      //   type: 'warning'
      // }).then(() => {
      //   // TODO: Implement project update logic
      //   this.$message({
      //     type: 'success',
      //     message: 'Cập nhật dự án thành công'
      //   });
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: 'Đã hủy cập nhật'
      //   });          
      // });
    },

    handleDeleteProject(projectId) {
      this.$confirm('Bạn có chắc chắn muốn xóa dự án này không?', 'Cảnh báo', {
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        const dataRes = ProjectApi.DeleteProject({
          ProjectId: projectId,
        }).then((res)=>{
          if(res.result){
            this.$notify.success({
              message: `Xóa dự án thành công`,
              duration: 3000,
              customClass: "doc-success",
            });

            if(this.projectDetails.id === projectId){
              this.projectDetails = {
                id: '',
                name: "Công việc của tôi"
              }
              this.tabs = 'work';
              this.initData();
              this.handleMenuSelect("");
            }
            else{
              this.projectLoaded();
            }
          }
          else{
            this.$notify.error({
              message: `Xóa dự án thất bại`,
              duration: 3000,
              customClass: "doc-warning",
            });
          }
        })
      }).catch(() => {
      });
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.ensureProjectMenusOpen();
  },

};
</script>
<style>
.sugesstion {
  border-bottom: 1px solid #D0D5D9;
  display: flex;
  align-items: center;
}

.sugesstion .infor {
  flex-wrap: wrap;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
}

.main .container-fluid {
  padding: 0 !important;
}

.container-fluid {
  padding-left: 0px;
  padding-right: 0px;
}

.my-work {
  width: 240px;
  height: 52px;
  gap: 18px;

  font-family: 'Lexend Deca';
  font-size: 15px;
  line-height: 52px;
  letter-spacing: 0%;
  cursor: pointer;
  margin: 0 auto;
  text-align: center;
  color: #292D32;

}

.my-work i {
  margin-right: 5px;
}

.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-tabs__header {
  border: none;
  margin: 0;
}

.left-menu-cong-viec {
  width: 240px !important;
  height: 100%;
  background: #FFFFFF;
}

.el-aside {
  color: #333;
  background: #FFFFFF;

}

.container-screen {
  height: 100vh;
  overflow-y: scroll;
}

.active-menu {
  background: #D0E8F5;
}

.row-flex {
  display: flex;

}

.el-submenu__title {
  width: 240px;
  height: 40px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 18px;
  box-sizing: border-box;
}

.item-raw {
  width: 240px;
  height: 52px;
  gap: 18px;
  padding-right: 10px;

}


.item-raw-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-left: 0 !important;
  font-family: 'Lexend Deca', sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
  height: 52px;
  width: 240px;
  align-items: center;

}


.project-name {
  font-size: 14px;
  color: #333;
}

.el-menu-item-group__title {
  padding-left: 0px !important;
}

.el-submenu .el-menu-item .item-raw-wrapper {
  padding: 0px;
}

.el-menu-item.item-raw-wrapper {
  padding-left: 20px !important;
}

.el-menu-item-group {
  height: 52px
}

.item-raw-wrapper:hover .more-icon {
  display: inline-block;
}

.item-raw-wrapper:hover {
  cursor: pointer;
  background: #D0E8F5;
}

.more-icon {
  display: none;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #292D32;
  cursor: pointer;
}

.header-band {
  height: 72px;
  top: 72px;
  left: 480px;
  box-shadow: 0px 2px 4px 0px #00000029;
  background: #FFFFFF;
}

.tabs-work .el-tabs__item {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  margin-right: 0px !important;
  background: #E9E9E9;
  border-bottom: 1px solid #D0D5D9;
  width: 204px;
  height: 50px;
  gap: 10px;
  padding-top: 13px;
  padding-bottom: 13px;

}

.el-tab {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.tab-text {
  font-family: ' Lexend Deca';
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0%;
  padding-left: 10px;
  color: #292D32;

}

.tabs-work .el-tabs__item {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  margin-right: 0px !important;
}

.tabs-work .el-tabs__item.is-active {
  background-color: #ffffff !important;
  border-top: 3px solid #F79E61 !important;
  border-bottom: none;
  border-right: none;
  border-left: none;
}

.screen-main {
  height: 902px;
  top: 224px;
  left: 504px;
  background: #FFFFFF;

}

.work-create {
  width: 262px;
  height: 56px;
  gap: 10px;
  border-radius: 4px;
  padding-top: 14px;
  padding-right: 40px;
  padding-bottom: 14px;
  padding-left: 40px;
  background: #4F8AAB;
  border: none;
  color: #ffffff;
  margin-top: 240px;
}

.create-button {
  display: flex;
  justify-content: center;
  width: 100%;
}

.filter-form {
  display: flex;
  gap: 20px;
  padding-left: 10px;
  padding-right: 10px;

  padding-top: 20px;
  flex-wrap: wrap;
}

.el-select {
  max-width: 180px;
}

.filter-form .el-select .el-input__inner {
  background: #D0E8F5;
  border: 1px solid #4F8AAB;
  height: 40px;
  gap: 10px;
  border-radius: 8px;
  border-width: 1px;
  padding-top: 8px;
  padding-right: 10px;
  padding-bottom: 8px;
  padding-left: 10px;
  font-size: 15px;
  line-height: 24px;
  font-family: 'Lexend Deca';
  color: #4F8AAB;

}



.filter-form .el-select,
.filter-form .dateform,
.filter-form .el-date-picker {
  flex-shrink: 0;
  /* Không bị co lại */
}

.dateform {
  display: flex;
  align-items: center;
  gap: 12px;
}

.row-flex {
  display: flex;
  align-items: center;
  gap: 6px;
}


.row-flex .title {
  font-family: 'Lexend Deca', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0;
  white-space: nowrap;
}

.el-input__inner::placeholder {
  font-family: 'Lexend Deca', sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
  color: #4F8AAB;
}

.screen-main .el-collapse-item__header {
  height: 60px;
  gap: 16px;
  padding: 16px;
  background: #4F8AAB;


}

.screen-main .el-table thead tr th {
  height: 48px;
  gap: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  background: #4F8AAB !important;
  color: #ffffff;
  border-top: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
}

.screen-main .el-collapse-item__content {
  padding: 0px;
}

.screen-main .el-collapse .el-collapse-item__header {
  border-radius: 0px;
  color: #ffffff;
  padding-left: 16px;
  padding-right: 16px;
}

.screen-main .el-collapse-item {
  margin-top: 16px !important;
  padding-left: 16px;
  padding-right: 16px;
}

.screen-main .el-table thead tr th:first-child {
  border-left: none;
}

.screen-main .el-table thead tr th:last-child {
  border-right: none;
}

.main-screen .create-button .work-create {
  margin-top: 10px;
}

.screen-main .el-table {
  border-radius: 0px;
}

/* .filter-form .el-date-picker .el-input__inner,
.filter-form .el-date-picker .el-input {
  width: 156px;
  height: 40px;
  padding: 12px 16px;
  border-radius: 5px;
  border-width: 1px;
  font-family: 'Lexend Deca', sans-serif;
  font-size: 14px;
  box-sizing: border-box;
}

.filter-form .el-date-picker .el-input__prefix {
  left: auto !important;
  right: 12px !important;
}

.filter-form .el-date-picker .el-input__prefix {
  pointer-events: none; 
}

  .filter-form .el-date-picker  .el-input__inner {
  padding-left: 16px !important;
  padding-right: 36px !important; 
  background: #FFFFFF;

} */
.el-table__row:hover>.el-table__cell {
  background: #D0E8F5 !important;
  cursor: pointer
}

.popup-content .project-name {
  font-family: Lexend Deca;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #7E7E7E;

}

.popup-content .task-name {
  font-family: Lexend Deca;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
  text-wrap: inherit;
  color: #292D32;
}

.popup-content .last-change {
  font-family: Lexend Deca;
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}

.popup-content .last-change .author {
  text-decoration: none;
  color: #20a8d8;
}

.assigner-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  height: 40px;
  border-radius: 8px;
  background: #D0E8F5;
  width: fit-content;
  margin-bottom: 16px;
  cursor: pointer;
  margin-right: 15px;
  position: relative;
}

.assigner-item.member:hover {
  border: 1px solid red;
}

.assigner-item.member .remove-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  line-height: 16px;
  display: none;
  cursor: pointer;
}

.assigner-item.member:hover .remove-btn {
  display: block;
}

.assigner-item .avatar {
  margin-right: 0px;
}

.task-element {
  display: flex;
  width: fit-content;
  flex-direction: column;
}

.task-element span {
  margin-bottom: 8px;
}

.task-type {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.popup-content .dateform {
  flex-wrap: wrap;
  margin-top: 24px;
}

.popup-content .dateform .time-picker {
  display: flex;
  flex-direction: column;
}

.popup-content .dateform .time-picker span {
  margin-bottom: 8px;
}

.popup-content .dateform .time-picker input {
  height: 40px;
}

.popup-content .note-form .title {
  text-align: left;
  margin-bottom: 8px;
}


.popup-content .note-form {
  margin-top: 24px;
}

.popup-content .note-form .el-textarea {
  margin-top: 8px;
}

.check-box-list {
  margin: 20px 0px;
}

.title #checklist-title {
  font-family: Lexend Deca;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #292D32;
}

.popup-content-delete {
  width: 300px;
}

.popup-content-delete p {
  font-size: 15px;
}

.checkbox-group {
  display: flex;
  flex-direction: column;

}

.checkbox-group .checkbox-item {
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  gap: 8px;

}

.checkbox-group .checkbox-item .task-list {
  font-family: Lexend Deca;
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;

}

.checkbox-item input[type="checkbox"] {
  top: 9px;
  left: 6px;
  border-width: 1.5px;
  accent-color: #1E3CD7;

}

.checkbox-item label {
  color: #1E3CD7;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 0px;
}

/* upload file */
.file-upload-container {
  font-family: Arial, sans-serif;
}

.upload-label {
  cursor: pointer;
  color: #007bff;
  text-decoration: underline;
  display: inline-block;
  margin-bottom: 0;

}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  cursor: pointer;
}


.file-item a {
  text-decoration: underline;
  color: #2a5bd7;
  font-weight: 500;
}

.file-upload-container .sub-upload {
  font-family: Lexend Deca;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #292D32;
  padding-top: 8px;
  padding-bottom: 8px;
  gap: 10px;
}

.upload-file {
  padding-top: 8px;
  padding-bottom: 8px;
}

.icon-up {
  width: 16px;
  height: 16px;
}

.icon-down {
  width: 14;
  height: 14;
  top: 1px;
  left: 1px;
  border-width: 1.25px;
  color: #4F8AAB;
}

/* ==== */
.file-wrapper {
  font-family: Arial, sans-serif;
}

.file-item {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.icon {
  width: 18px;
  margin-right: 6px;
}

.file-name {
  font-size: 14px;
  color: #1a5cc8;
  text-decoration: underline;
  cursor: default;
  flex: 1;
}

.remove-btn {
  color: #999;
  font-size: 16px;
  cursor: pointer;
  margin-left: 8px;
  transition: color 0.2s;
}

.remove-btn:hover {
  color: red;
}

.upload-box {
  border: 1px dashed #ccc;
  padding: 8px 12px;
  color: #666;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  margin-top: 8px;
  border-radius: 4px;
  user-select: none;
}

.upload-file,
.work-add {
  font-family: Lexend Deca;
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #444242;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  border: 1px solid #ABABAB;
  width: 324px;
  border-radius: 5px;
  height: 40px;
  cursor: pointer;
}

.file-name-truncate {
  max-width: 260px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.assign-content {
  width: 400px;
}

/* CSS cho phần Thành viên dự án */
.my-member-screen {
  padding: 16px;
  background-color: #fff;
}

/* Khu vực nút thêm thành viên */
.member-actions {
  margin-bottom: 16px;
}

.no-header-table thead {
  display: none;
}

.add-member-btn {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.add-member-btn:hover {
  background-color: #f5f5f5;
}

/* Thẻ thành viên */
.member-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
  transition: background-color 0.2s ease;
}

.member-card:hover {
  background-color: #f9f9f9;
}

/* Avatar */
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
  border: 1px solid #e0e0e0;
}

/* Thông tin thành viên */
.member-info {
  flex: 1;
}

.member-info h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

.member-info p {
  margin: 4px 0 0;
  font-size: 13px;
  color: #767676;
}

/* Khu vực nút */
.member-buttons {
  display: flex;
  gap: 8px;
}

.member-btn {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.member-btn:hover {
  background-color: #ebebeb;
}

.member-btn.danger {
  color: #e53935;
}

.member-btn.danger:hover {
  background-color: #ffebee;
  border-color: #ffcdd2;
}

/* CSS cho phần Thành viên dự án */
.my-member-screen {
  padding: 16px;
  background-color: #fff;
}

/* Khu vực nút thêm thành viên */
.member-actions {
  margin-bottom: 16px;
}

.add-member-btn {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.add-member-btn:hover {
  background-color: #f5f5f5;
}

/* Thẻ thành viên */
.member-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
  transition: background-color 0.2s ease;
}

.member-card:hover {
  background-color: #f9f9f9;
}

/* Avatar */
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
  border: 1px solid #e0e0e0;
}

/* Thông tin thành viên */
.member-info {
  flex: 1;
}

.member-info h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

.member-info p {
  margin: 4px 0 0;
  font-size: 13px;
  color: #767676;
}

/* Khu vực nút */
.member-buttons {
  display: flex;
  gap: 8px;
}

.member-btn {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.member-btn:hover {
  background-color: #ebebeb;
}

.member-btn.danger {
  color: #e53935;
}

.member-btn.danger:hover {
  background-color: #ffebee;
  border-color: #ffcdd2;
}

/* CSS chung cho tất cả các modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-20px);
  transition: transform 0.3s ease;
}

.modal-overlay.active .modal-content {
  transform: translateY(0);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-body {
  margin-bottom: 24px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.modal-btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.modal-btn-cancel {
  background-color: #f5f5f5;
  color: #555;
  border-color: #e0e0e0;
}

.modal-btn-cancel:hover {
  background-color: #ebebeb;
}

.modal-btn-submit {
  background-color: #1e88e5;
  color: white;
}
.radio-element{
  display: flex;
  margin-top: 8px;
  flex-wrap: wrap;
}
.radio-element .el-radio {
  display: flex;
  /* flex-direction: column; */
}
.radio-element .el-radio:not(:first-child) {
  margin-left: 8px;
}

.modal-btn-submit:hover {
  background-color: #1976d2;
}

.modal-btn-confirm {
  background-color: #e53935;
  color: white;
}

.modal-btn-confirm:hover {
  background-color: #d32f2f;
}

/* CSS cho form trong modal */
.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}

.form-control:focus {
  border-color: #1e88e5;
  outline: none;
}

select.form-control {
  cursor: pointer;
  background-color: #fff;
}

.avatar-upload {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.avatar-preview {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
  border: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-upload-btn {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.avatar-upload-btn:hover {
  background-color: #ebebeb;
}

.member-info-display {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.create-work .work-create {
  margin-top: 0px;
  width: fit-content;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
}

.create-work .work-create {
  margin-right: 0px;
}

.avatar-preview {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  overflow: hidden;
}

.avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.member-details h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.member-details p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #767676;
}

/* Responsive */
@media (max-width: 768px) {
  .member-buttons {
    flex-direction: column;
  }

  .member-card {
    flex-wrap: wrap;
  }

  .member-info {
    width: calc(100% - 60px);
    margin-bottom: 8px;
  }

  .member-buttons {
    width: 100%;
    margin-left: 56px;
  }

  .modal-content {
    width: 95%;
    padding: 16px;
  }

  .modal-header,
  .modal-footer {
    padding: 12px 0;
  }
}

/* CSS cho phần tìm kiếm có nút tìm kiếm */
.search-input-group {
  display: flex;
  gap: 8px;
}

.search-input-group .form-control {
  flex: 1;
}

.search-btn {
  background-color: #1e88e5;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.search-btn:hover {
  background-color: #1976d2;
}

/* CSS cho khung tìm kiếm thành viên */
.search-results {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 16px;
  margin-top: 12px;
}

.search-result-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background-color: #f5f5f5;
}

.search-result-item .avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
}

.user-info {
  flex: 1;
}

.user-info h4 {
  margin: 0 0 4px 0;
  font-size: 14px;
}

.user-info p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

/* CSS cho phần tìm kiếm có nút tìm kiếm */
.search-input-group {
  display: flex;
  gap: 8px;
}

.search-input-group .form-control {
  flex: 1;
}

.search-btn {
  background-color: #1e88e5;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.search-btn:hover {
  background-color: #1976d2;
}

/* CSS cho khung tìm kiếm thành viên */
.search-results {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 250px;
  /* Tăng chiều cao tối đa */
  overflow-y: auto;
  /* Tạo thanh cuộn theo chiều dọc khi nội dung vượt quá */
  margin-bottom: 16px;
  margin-top: 12px;
  scrollbar-width: thin;
  /* Cho Firefox */
  scrollbar-color: #bbbbbb #f0f0f0;
  /* Cho Firefox */
}

.search-result-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background-color: #f5f5f5;
}

.search-result-item .avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
}

.user-info {
  flex: 1;
}

.user-info h4 {
  margin: 0 0 4px 0;
  font-size: 14px;
}

.user-info p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

/* CSS cho phần hiển thị thành viên đã chọn */
.member-info-display {
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  position: relative;
}

.member-details {
  flex: 1;
}

.member-details h4 {
  margin: 0 0 4px 0;
  font-size: 14px;
}

.member-details p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

.popup-content .delete p {
  font-size: 15px;
}


/* Nút X để hủy chọn thành viên */
.member-remove-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.member-remove-btn:hover {
  background-color: #d32f2f;
}

/* Tùy chỉnh thanh cuộn cho các trình duyệt Chrome, Edge, Safari */
.search-results::-webkit-scrollbar {
  width: 6px;
}

.search-results::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.search-results::-webkit-scrollbar-thumb {
  background: #bbbbbb;
  border-radius: 4px;
}

.search-results::-webkit-scrollbar-thumb:hover {
  background: #999999;
}

@media (max-width: 576px) {
  .search-input-group {
    flex-direction: column;
  }

  .search-btn {
    width: 100%;
  }

  .member-info-display {
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 16px;
  }

  .avatar-preview {
    margin-right: 0;
    margin-bottom: 8px;
  }

  .member-remove-btn {
    top: 8px;
    right: 8px;
  }

}

.el-dialog__body {
  word-break: break-word;
  white-space: initial;
  max-height: 80vh;
  overflow: scroll;
}

.popupDialog .el-dialog__body {
  overflow: visible !important;
}

.el-dialog {
  margin-top: 5vh !important;
}

.create-work-content .task-type{
  margin-top: 8px;
}

.create-work-content .dateform{
  margin-top: 20px;
}

.create-work-content .note-form{
  margin-top: 8px;
}


.add-project-btn {
  width: 240px;
  height: 52px;
  gap: 18px;

  font-family: 'Lexend Deca';
  font-size: 15px;
  line-height: 52px;
  letter-spacing: 0%;
  cursor: pointer;
  margin: 0 auto;
  text-align: center;
  color: #292D32;

}

.add-project-btn i {
  margin-right: 5px;
}
.required{
  font-size: 20px;
  color: red;
}
.error {
  color: red;
  font-size: 13px;
  margin-top: 4px;
}

/* Đánh dấu viền đỏ cho el-input, el-select, date-picker */
.el-input.is-error .el-input__inner,
.el-select.is-error .el-input__inner,
.el-date-editor.is-error .el-input__inner {
  border-color: red !important;
}

.popupDialog .create-project-input .el-input__inner {
  color: #000;
}

.popupDialog .create-project-input .el-input__inner::placeholder {
  color: rgba(0, 0, 0, 0.45);
  opacity: 1;
}

.create-work-content .create-work-placeholder-field .el-input__inner {
  color: #000;
}

.create-work-content .create-work-placeholder-field .el-input__inner::placeholder,
.create-work-content .create-work-placeholder-field .el-select__input::placeholder {
  color: rgba(0, 0, 0, 0.45);
  opacity: 1;
}
@media (max-width: 767px) {
  .common-layout .container-screen { flex-direction: column; height: auto; overflow: visible; }
  .common-layout .left-menu-cong-viec { width: 100% !important; height: auto; max-height: 220px; overflow-y: auto; flex-shrink: 0; }
  .left-menu-cong-viec .my-work, .left-menu-cong-viec .el-submenu__title, .left-menu-cong-viec .item-raw, .left-menu-cong-viec .el-menu-item { width: 100%; }
  .container-screen > .el-container { min-width: 0; width: 100%; }
  .common-layout .el-main { padding: 12px; min-width: 0; }
  .common-layout .screen-main { height: auto; min-height: 320px; }
  .filter-form { padding: 12px 0; gap: 12px; }
  .filter-form .el-select { width: 100%; max-width: none; }
  .filter-form .dateform { width: 100%; flex-wrap: wrap; }
  .filter-form .time-picker { width: 100%; justify-content: space-between; }
  .filter-form .time-picker .el-date-editor { width: calc(100% - 95px) !important; }
}
</style>

